import React, { useState } from 'react';

const ResellerPanel = ({ isVisible, onBack, API_BASE }) => {
    // وضعیت‌های لاگین
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false); 
    const [loading, setLoading] = useState(false);
    
    // اطلاعات نماینده و تاریخچه لایسنس‌ها
    const [resellerInfo, setResellerInfo] = useState(null);
    const [licenses, setLicenses] = useState([]);

    // وضعیت‌های فرم صدور لایسنس
    const [clientName, setClientName] = useState('');
    const [clientMobile, setClientMobile] = useState('');
    const [hwid, setHwid] = useState('');
    const [product, setProduct] = useState(''); // تغییر به مقدار خالی برای تنظیم داینامیک
    const [genLoading, setGenLoading] = useState(false);
    const [genResult, setGenResult] = useState(null);

    // تابع دریافت اطلاعات بروزشده نماینده و لیست فروش‌ها
    const fetchResellerInfo = async (resellerId) => {
        try {
            const res = await fetch(`${API_BASE}/reseller.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_info', reseller_id: resellerId })
            });
            const data = await res.json();
            if (data.success) {
                setResellerInfo(data.reseller);
                setLicenses(data.licenses || []);
                
                // تنظیم اولین محصول مجاز به عنوان انتخاب پیش‌فرض در صورت عدم انتخاب قبلی
                if (data.reseller.allowed_products && !product) {
                    const allowedArr = data.reseller.allowed_products.split(',').map(p => p.trim());
                    if (allowedArr.length > 0) setProduct(allowedArr[0]);
                }
            }
        } catch (err) {
            console.error("Error fetching reseller history:", err);
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!username.trim() || !password.trim()) {
            alert('لطفاً نام کاربری و رمز عبور را وارد کنید.');
            return;
        }
        setLoading(true);
        try {
            const res = await fetch(`${API_BASE}/reseller.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'login', username, password })
            });
            const data = await res.json();
            if (data.success) {
                setIsLoggedIn(true);
                setResellerInfo(data.reseller);
                
                // تنظیم اولین محصول مجاز همکار به عنوان محصول انتخابی پیش‌فرض
                if (data.reseller.allowed_products) {
                    const allowedArr = data.reseller.allowed_products.split(',').map(p => p.trim());
                    if (allowedArr.length > 0) setProduct(allowedArr[0]);
                }
                
                fetchResellerInfo(data.reseller.id);
            } else {
                alert(data.error || 'نام کاربری یا رمز عبور اشتباه است.');
            }
        } catch (err) {
            alert('خطا در ارتباط با سرور');
        } finally {
            setLoading(false);
        }
    };

    const handleGenerateLicense = async (e) => {
        e.preventDefault();
        if (!clientName.trim() || !clientMobile.trim() || !hwid.trim()) {
            alert('لطفاً تمام فیلدها (نام، موبایل و HWID) را تکمیل کنید.');
            return;
        }
        setGenLoading(true);
        setGenResult(null);
        try {
            const res = await fetch(`${API_BASE}/reseller.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'generate_license',
                    reseller_id: resellerInfo.id,
                    product: product,
                    name: clientName,
                    mobile: clientMobile,
                    hwid: hwid
                })
            });
            const data = await res.json();
            if (data.success) {
                setGenResult(data);
                setClientName('');
                setClientMobile('');
                setHwid('');
                fetchResellerInfo(resellerInfo.id);
            } else {
                alert(data.error || 'خطا در صدور لایسنس');
            }
        } catch (err) {
            alert('خطا در ارتباط با سرور');
        } finally {
            setGenLoading(false);
        }
    };

    // پردازش امن داده‌های نمودار فروش بدون نیاز به کتابخانه خارجی
    const getAnalyticsData = () => {
        const now = new Date();
        
        // ساخت ظرف ۷ روز اخیر
        const dailySales = Array(7).fill(0).map((_, i) => {
            const d = new Date();
            d.setDate(now.getDate() - i);
            return {
                dayName: d.toLocaleDateString('fa-IR', { weekday: 'long' }),
                dateString: d.toDateString(),
                count: 0
            };
        }).reverse();

        // ساخت ظرف ۶ ماه اخیر
        const monthlySales = Array(6).fill(0).map((_, i) => {
            const d = new Date();
            d.setMonth(now.getMonth() - i);
            return {
                monthName: d.toLocaleDateString('fa-IR', { month: 'long' }),
                year: d.getFullYear(),
                month: d.getMonth(),
                count: 0
            };
        }).reverse();

        // دسته‌بندی لایسنس‌ها بر اساس زمان ایجاد
        if (Array.isArray(licenses)) {
            licenses.forEach(lic => {
                if (!lic || !lic.created_at) return;
                const licDate = new Date(lic.created_at);
                if (isNaN(licDate.getTime())) return;

                // بررسی تطابق روز
                const foundDay = dailySales.find(d => d.dateString === licDate.toDateString());
                if (foundDay) foundDay.count++;

                // بررسی تطابق ماه و سال
                const foundMonth = monthlySales.find(m => m.year === licDate.getFullYear() && m.month === licDate.getMonth());
                if (foundMonth) foundMonth.count++;
            });
        }

        return { dailySales, monthlySales };
    };

    const { dailySales, monthlySales } = getAnalyticsData();
    const maxDailyCount = Math.max(...dailySales.map(d => d.count), 1);
    const maxMonthlyCount = Math.max(...monthlySales.map(m => m.count), 1);

    if (!isVisible) return null;

    return (
        <div className="min-h-screen bg-[#0f172a] text-slate-100 p-4 md:p-8" style={{ direction: 'rtl' }}>
            <style>{`
                .login-box-wrapper {
                    position: relative;
                    width: 100%;
                    max-width: 800px;
                    height: 65vh;
                    min-height: 500px;
                    background: #081b29;
                    box-shadow: 0 0 50px 0 #00a6bc;
                    border: 3px solid #00ffff;
                    overflow: hidden;
                    border-radius: 8px;
                }
                .neon-input {
                    border: none;
                    outline: none;
                    background: none;
                    border-bottom: 2px solid #eee;
                    width: 100%;
                    padding: 10px 10px 10px 0;
                    font-size: 17px;
                    color: #0ef;
                    transition: border-color 0.3s;
                }
                .neon-input::placeholder {
                    color: #eee;
                    opacity: 0.7;
                }
                .neon-input:focus {
                    border-bottom-color: #0ef;
                }
                .neon-submit {
                    border: none;
                    outline: none;
                    width: 100%;
                    margin-top: 25px;
                    padding: 12px 0;
                    font-size: 20px;
                    border-radius: 40px;
                    letter-spacing: 1px;
                    cursor: pointer;
                    background: linear-gradient(45deg, #0ef, #c800ff);
                    color: #fff;
                    font-weight: bold;
                    transition: transform 0.2s;
                }
                .neon-submit:hover {
                    transform: scale(1.02);
                    box-shadow: 0 0 15px #0ef;
                }
                .neon-submit:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }
            `}</style>

            <div className="max-w-6xl mx-auto flex justify-between items-center mb-8 border-b border-slate-800 pb-4">
                <div>
                    <h1 className="text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-emerald-400">
                        پنل نمایندگان فروش و همکاران
                    </h1>
                    {isLoggedIn && resellerInfo && (
                        <p className="text-sm text-slate-400 mt-1">
                            همکار گرامی: <span className="text-cyan-400 font-bold">{resellerInfo.full_name}</span> خوش آمدید.
                        </p>
                    )}
                </div>
                <button 
                    onClick={onBack}
                    className="bg-slate-800 hover:bg-slate-700 text-slate-300 px-4 py-2 rounded-xl text-sm font-bold transition-all border border-slate-700/50 cursor-pointer"
                >
                    بازگشت به منو اصلی
                </button>
            </div>

            <div className="max-w-6xl mx-auto">
                {!isLoggedIn ? (
                    <div className="flex items-center justify-center py-10">
                        <div className="login-box-wrapper grid grid-cols-1 md:grid-cols-2">
                            <div className="flex flex-col justify-center items-center p-8 relative z-10">
                                <h2 className="text-3xl font-bold text-white mb-2">خوش آمدید</h2>
                                <p className="text-[#0ef] mb-10 text-sm">ورود به حساب همکار</p>
                                
                                <form onSubmit={handleLogin} className="w-full max-w-[260px] flex flex-col items-center">
                                    <div className="w-full mb-6">
                                        <input 
                                            type="text" 
                                            className="neon-input" 
                                            placeholder="نام کاربری" 
                                            value={username} 
                                            onChange={(e) => setUsername(e.target.value)} 
                                        />
                                    </div>
                                    <div className="w-full mb-8 relative">
                                        <input 
                                            type={showPassword ? "text" : "password"} 
                                            className="neon-input" 
                                            placeholder="رمز عبور" 
                                            value={password} 
                                            onChange={(e) => setPassword(e.target.value)} 
                                        />
                                        <button 
                                            type="button" 
                                            onClick={() => setShowPassword(!showPassword)} 
                                            className="absolute left-0 top-3 text-[#0ef] hover:text-white transition-colors"
                                        >
                                            {showPassword ? (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" y1="2" x2="22" y2="22"/></svg>
                                            ) : (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>
                                            )}
                                        </button>
                                    </div>
                                    <button type="submit" disabled={loading} className="neon-submit">
                                        {loading ? 'در حال بررسی...' : 'ورود'}
                                    </button>
                                </form>
                            </div>

                            <div className="hidden md:flex flex-col justify-center items-end text-right p-10 relative bg-gradient-to-r from-[#0ef] to-[#c800ff]" style={{ clipPath: "polygon(0 0, 100% 0, 100% 100%, 20% 100%)" }}>
                                <div className="ml-auto w-full max-w-[280px] mt-[-50px]">
                                    <h2 className="text-4xl font-bold text-white mb-4 drop-shadow-md">ارکانی عمران</h2>
                                    <p className="text-lg text-white/90 leading-relaxed font-medium drop-shadow-sm">
                                        پنل اختصاصی همکاران جهت صدور آنی لایسنس و مدیریت فروش
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="space-y-8">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div className="p-[1px] rounded-2xl bg-gradient-to-r from-cyan-500 via-slate-700 to-emerald-500 shadow-md">
                                <div className="bg-slate-900/90 p-4 rounded-[15px] flex items-center justify-between h-full">
                                    <div>
                                        <p className="text-xs text-slate-400 font-semibold">کل سهمیه اعتبار لایسنس</p>
                                        <h3 className="text-2xl font-black text-cyan-400 mt-1">{resellerInfo?.allowed_credits}</h3>
                                    </div>
                                    <div className="bg-cyan-500/10 p-3 rounded-xl text-cyan-400">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div className="p-[1px] rounded-2xl bg-gradient-to-r from-cyan-500 via-slate-700 to-emerald-500 shadow-md">
                                <div className="bg-slate-900/90 p-4 rounded-[15px] flex items-center justify-between h-full">
                                    <div>
                                        <p className="text-xs text-slate-400 font-semibold">تعداد لایسنس صادر شده</p>
                                        <h3 className="text-2xl font-black text-emerald-400 mt-1">{resellerInfo?.used_credits}</h3>
                                    </div>
                                    <div className="bg-emerald-500/10 p-3 rounded-xl text-emerald-400">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div className="p-[1px] rounded-2xl bg-gradient-to-r from-cyan-500 via-slate-700 to-emerald-500 shadow-md">
                                <div className="bg-slate-900/90 p-4 rounded-[15px] flex items-center justify-between h-full">
                                    <div>
                                        <p className="text-xs text-slate-400 font-semibold">سهمیه باقی‌مانده شما</p>
                                        <h3 className="text-2xl font-black text-amber-400 mt-1">
                                            {Math.max(0, (resellerInfo?.allowed_credits || 0) - (resellerInfo?.used_credits || 0))}
                                        </h3>
                                    </div>
                                    <div className="bg-amber-500/10 p-3 rounded-xl text-amber-400">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="p-[1px] rounded-2xl bg-gradient-to-br from-cyan-500 via-purple-500 to-emerald-500 shadow-lg">
                                <div className="bg-slate-900/95 p-5 rounded-[15px] h-full">
                                    <h3 className="text-sm font-bold text-slate-300 mb-6 flex items-center gap-2">
                                        <span className="w-2 h-2 rounded-full bg-cyan-400 shadow-[0_0_8px_#0ef]"></span>
                                        آنالیز فروش هفته اخیر (توزیع روزانه)
                                    </h3>
                                    <div className="flex items-end justify-between h-32 pt-4 px-2 gap-3 border-b border-slate-800 pb-1">
                                        {dailySales.map((day, idx) => (
                                            <div key={idx} className="flex flex-col items-center flex-1 group relative">
                                                <div className="absolute top-[-26px] bg-slate-950 border border-cyan-500/40 text-cyan-400 font-mono text-[10px] font-bold px-1.5 py-0.5 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-20 whitespace-nowrap">
                                                    {day.count} عدد
                                                </div>
                                                <div 
                                                    className="w-full bg-gradient-to-t from-cyan-600/80 to-cyan-400 rounded-t-md transition-all duration-300 shadow-[0_0_10px_rgba(0,238,255,0.1)] hover:from-cyan-400 hover:to-cyan-300"
                                                    style={{ height: `${(day.count / maxDailyCount) * 100}%`, minHeight: day.count > 0 ? '8px' : '2px' }}
                                                ></div>
                                                <span className="text-[10px] text-slate-500 mt-2 truncate w-full text-center group-hover:text-cyan-400 transition-colors">
                                                    {day.dayName.replace('شنبه', 'ش')}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="p-[1px] rounded-2xl bg-gradient-to-br from-cyan-500 via-purple-500 to-emerald-500 shadow-lg">
                                <div className="bg-slate-900/95 p-5 rounded-[15px] h-full">
                                    <h3 className="text-sm font-bold text-slate-300 mb-6 flex items-center gap-2">
                                        <span className="w-2 h-2 rounded-full bg-emerald-400 shadow-[0_0_8px_#10b981]"></span>
                                        آنالیز روند فروش ماه‌های اخیر
                                    </h3>
                                    <div className="flex items-end justify-between h-32 pt-4 px-2 gap-3 border-b border-slate-800 pb-1">
                                        {monthlySales.map((month, idx) => (
                                            <div key={idx} className="flex flex-col items-center flex-1 group relative">
                                                <div className="absolute top-[-26px] bg-slate-950 border border-emerald-500/40 text-emerald-400 font-mono text-[10px] font-bold px-1.5 py-0.5 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-20 whitespace-nowrap">
                                                    {month.count} عدد
                                                </div>
                                                <div 
                                                    className="w-full bg-gradient-to-t from-emerald-600/80 to-emerald-400 rounded-t-md transition-all duration-300 shadow-[0_0_10px_rgba(16,185,129,0.1)] hover:from-emerald-400 hover:to-emerald-300"
                                                    style={{ height: `${(month.count / maxMonthlyCount) * 100}%`, minHeight: month.count > 0 ? '8px' : '2px' }}
                                                ></div>
                                                <span className="text-[10px] text-slate-500 mt-2 truncate w-full text-center group-hover:text-emerald-400 transition-colors">
                                                    {month.monthName}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                            <div className="lg:col-span-2 p-[1px] rounded-2xl bg-gradient-to-r from-cyan-500 via-indigo-500 to-emerald-500 shadow-lg">
                                <div className="bg-slate-900/95 p-6 rounded-[15px] h-full">
                                    <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
                                        <span className="w-2 h-2 rounded-full bg-cyan-400"></span>
                                        صدور کلید لایسنس جدید
                                    </h3>
                                    <form onSubmit={handleGenerateLicense} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-xs font-semibold text-slate-400 mb-2">نام و نام‌خانوادگی مشتری</label>
                                            <input 
                                                type="text"
                                                value={clientName}
                                                onChange={(e) => setClientName(e.target.value)}
                                                className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2.5 text-sm text-white focus:outline-none focus:border-cyan-500 transition-colors"
                                                placeholder="مثال: رضا احمدی"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-slate-400 mb-2">شماره موبایل مشتری</label>
                                            <input 
                                                type="text"
                                                value={clientMobile}
                                                onChange={(e) => setClientMobile(e.target.value)}
                                                className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2.5 text-sm text-white text-left font-mono focus:outline-none focus:border-cyan-500 transition-colors"
                                                placeholder="09123456789"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-slate-400 mb-2">نوع نرم‌افزار (محصول)</label>
                                            <select 
                                                value={product}
                                                onChange={(e) => setProduct(e.target.value)}
                                                className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2.5 text-sm text-white focus:outline-none focus:border-cyan-500 transition-colors cursor-pointer"
                                            >
                                                {resellerInfo?.allowed_products ? (
                                                    resellerInfo.allowed_products.split(',').map((p) => {
                                                        const prodName = p.trim();
                                                        if (!prodName) return null;
                                                        
                                                        let displayName = prodName;
                                                        if (prodName === 'SteeliCa') displayName = 'SteeliCa (طراحی سازه‌های فولادی)';
                                                        if (prodName === 'BetoniCa') displayName = 'BetoniCa (طراحی سازه‌های بتنی)';
                                                        if (prodName === 'EtaNex') displayName = 'EtaNex (طراحی اتصالات فولادی)';
                                                        if (prodName === 'SeismiCa') displayName = 'SeismiCa (طراحی لرزه‌ای)';
														if (prodName === 'WalliCa') displayName = 'WalliCa (طراحی دیوار برشی)';
                                                        if (prodName === 'StructiCa') displayName = 'StructiCa (تحلیل و طراحی خرپای فضایی در راینو)';
                                                        
                                                        return (
                                                            <option key={prodName} value={prodName}>{displayName}</option>
                                                        );
                                                    })
                                                ) : (
                                                    <>
                                                        <option value="SteeliCa">SteeliCa (طراحی سازه‌های فولادی)</option>
                                                        <option value="BetoniCa">BetoniCa (طراحی سازه‌های بتنی)</option>
                                                        <option value="EtaNex">EtaNex (در تعامل با ایتبس)</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-slate-400 mb-2">کد سخت‌افزاری دستگاه (HWID)</label>
                                            <input 
                                                type="text"
                                                value={hwid}
                                                onChange={(e) => setHwid(e.target.value)}
                                                className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2.5 text-sm text-white text-left font-mono tracking-wider focus:outline-none focus:border-cyan-500 transition-colors"
                                                placeholder="۱۶ رقم هگزادسیمال"
                                            />
                                        </div>
                                        <div className="md:col-span-2 mt-2">
                                            <button 
                                                type="submit"
                                                disabled={genLoading}
                                                className="w-full md:w-auto bg-gradient-to-r from-cyan-500 to-emerald-500 hover:from-cyan-600 hover:to-emerald-600 text-slate-950 font-black px-8 py-3 rounded-xl transition-all shadow-lg cursor-pointer disabled:opacity-50"
                                            >
                                                {genLoading ? 'در حال محاسبه و ثبت...' : 'تولید و ثبت آنی لایسنس'}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <div className="p-[1px] rounded-2xl bg-gradient-to-br from-emerald-500 via-purple-500 to-cyan-500 shadow-lg">
                                <div className="bg-slate-900/95 p-6 rounded-[15px] flex flex-col justify-center items-center min-h-[200px] h-full">
                                    {genResult?.success ? (
                                        <div className="text-center w-full">
                                            <div className="text-emerald-500 mx-auto mb-3 flex justify-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </div>
                                            <h3 className="text-base font-bold text-white mb-1">لایسنس صادر شد!</h3>
                                            <p className="text-xs text-slate-400 mb-4">کلید فعال‌سازی برای تحویل به کاربر:</p>
                                            <div className="bg-slate-950 p-3 rounded-xl border border-emerald-500/30 flex justify-between items-center gap-3">
                                                <code className="text-lg text-emerald-400 font-mono font-bold tracking-widest">{genResult.license_key}</code>
                                                <button 
                                                    onClick={() => { navigator.clipboard.writeText(genResult.license_key); alert('کلید لایسنس با موفقیت کپی شد!'); }} 
                                                    className="bg-slate-800 hover:bg-slate-700 text-white text-xs px-2.5 py-1.5 rounded-lg border border-slate-700 transition-colors cursor-pointer"
                                                >
                                                    کپی
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="text-center text-slate-500">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mx-auto mb-2 text-slate-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                                            </svg>
                                            <p className="text-xs">پس از تکمیل فرم، کلید جدید در اینجا نمایش داده می‌شود.</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="p-[1px] rounded-2xl bg-gradient-to-r from-cyan-500 via-purple-500 to-emerald-500 shadow-lg">
                            <div className="bg-slate-900/95 p-6 rounded-[15px]">
                                <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
                                    <span className="w-2 h-2 rounded-full bg-emerald-400"></span>
                                    لیست مشتریان و تاریخچه لایسنس‌های فروخته شده
                                </h3>
                                
                                {licenses.length === 0 ? (
                                    <p className="text-slate-500 text-sm text-center py-6">هنوز هیچ لایسنسی توسط حساب شما صادر نشده است.</p>
                                ) : (
                                    <div className="overflow-x-auto">
                                        <table className="w-full text-right text-sm border-collapse">
                                            <thead>
                                                <tr className="border-b border-slate-800 text-slate-400 text-xs">
                                                    <th className="pb-3 font-semibold px-2">ردیف</th>
                                                    <th className="pb-3 font-semibold px-2">نام مشتری</th>
                                                    <th className="pb-3 font-semibold px-2">شماره موبایل</th>
                                                    <th className="pb-3 font-semibold px-2">محصول</th>
                                                    <th className="pb-3 font-semibold px-2">کد سخت‌افزاری (HWID)</th>
                                                    <th className="pb-3 font-semibold px-2">کلید لایسنس صادر شده</th>
                                                    <th className="pb-3 font-semibold px-2">تاریخ صدور شمسی</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-slate-800/50">
                                                {licenses.map((lic, index) => (
                                                    <tr key={lic.id || index} className="hover:bg-slate-800/20 transition-colors text-slate-200">
                                                        <td className="py-3.5 px-2 font-mono text-slate-500 text-xs">{index + 1}</td>
                                                        <td className="py-3.5 px-2 font-bold text-white">{lic.name || '---'}</td>
                                                        <td className="py-3.5 px-2 font-mono text-slate-300 text-xs text-left md:text-right">{lic.mobile || '---'}</td>
                                                        <td className="py-3.5 px-2">
                                                            <span className="px-2 py-0.5 rounded text-xs font-semibold bg-cyan-500/10 text-cyan-400">
                                                                {lic.product || 'SteeliCa'}
                                                            </span>
                                                        </td>
                                                        <td className="py-3.5 px-2 font-mono text-xs text-slate-400 tracking-wider text-left md:text-right">{lic.hwid}</td>
                                                        <td className="py-3.5 px-2 font-mono text-emerald-400 font-bold tracking-widest text-xs">
                                                            <div className="bg-slate-950 px-2 py-1 rounded border border-emerald-500/10 flex items-center justify-between max-w-[150px]">
                                                                <span>{lic.license_key}</span>
                                                                <button 
                                                                    onClick={() => { navigator.clipboard.writeText(lic.license_key); alert('کپی شد!'); }}
                                                                    className="text-slate-500 hover:text-white text-[10px] pr-2 cursor-pointer transition-colors"
                                                                >
                                                                    کپی
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td className="py-3.5 px-2 text-xs text-slate-400 font-mono">
                                                            {lic.created_at ? new Date(lic.created_at).toLocaleDateString('fa-IR') : '---'}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ResellerPanel;